import * as helper from './../../../../../VX/View/Assets/Js/helper';

export default class Radiobox {
	constructor(elements) {
		this.boxes = elements;
		this.selected = false;

		for (let element of this.boxes) {
			helper.addEventListener(element, 'click', (evt) => {
				evt.preventDefault();
				this._update(evt.currentTarget);
			});
		}
	}

	get value() {
		return this.selected;
	}

	isValid() {
		for (let box of this.boxes) {
			const selector = box.querySelector('.question-box-2');
			if (helper.hasClass(selector, 'active')) {
				return true;
			}
		}

		return false;
	}

	get values() {
		return this.selected;
	}

	_update(element) {
		for (let box of this.boxes) {
			const selector = box.querySelector('.question-box-2');
			const icon = selector.querySelector('i');

			helper.removeClass(selector, 'active');
			helper.removeClass(icon, 'fa-check-circle');
			helper.removeClass(icon, 'fas');
			helper.addClass(icon, 'fa-circle');
			helper.addClass(icon, 'fal');

			if (box === element) {
				this.selected = helper.getData(element, 'selection');

				helper.addClass(selector, 'active');
				helper.addClass(icon, 'fa-check-circle');
				helper.addClass(icon, 'fas');
				helper.removeClass(icon, 'fa-circle');
				helper.removeClass(icon, 'fal');
			}
		}
	}
}
